import { useState } from "react";
import { type ApolloError } from "@apollo/client";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const useCreateHealthcareProviderExcerpt = () => {
    // Todo: actually implement the loading and errors
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [error, setError] = useState<ApolloError>();
    const { t } = useTranslation("common", {
        keyPrefix: "healthcare-provider-excerpts-create",
    });

    const schema = yup
        .object({
            healthcareProvider: yup
                .object()
                .shape({
                    id: yup.string().required(),
                    name: yup.string().required(),
                    cocNumber: yup.string().required(),
                })
                .required(t("healthcareProvider.required") ?? void 0),
        })
        .required();

    const form = useForm<yup.InferType<typeof schema>>({
        resolver: yupResolver(schema),
        reValidateMode: "onChange",
        mode: "onChange",
    });

    return {
        form,
        loading,
        error,
    };
};
